<template>
  <span>
    <div class="vx-row">
      <div class="w-full vx-col">
        <vs-tabs id="dry-costing-tabs" position="top" class="tabs-shadow-none">
          <vs-tab label="3rd Party RMs">
            <div class="tab-general">
              <SprayDryCarrier />
            </div>
          </vs-tab>
          <vs-tab label="Toll Drying costs">
            <div class="tab-general">
              <TollDryingSizes />
            </div>
          </vs-tab>

          <vs-tab label="Spray Dry Sundry">
            <div class="tab-general">
              <SprayDrySundry />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </span>
</template>
<script>
import SprayDryCarrier from "./tabs/SprayDryCarrier.vue";
import TollDryingSizes from "./tabs/TollDryingSizes.vue";
import SprayDrySundry from "./tabs/SprayDrySundry.vue";
export default {
  name: "SprayDryCostSettings",
  components: {
    TollDryingSizes,
    SprayDryCarrier,
    SprayDrySundry,
  },
};
</script>

<style lang="scss">
#dry-costing-tabs {
  width: 100%;

  .vs-tabs--ul {
    display: flex;
  }

  .vs-tabs-position-bottom .vs-tabs--ul,
  .vs-tabs-position-top .vs-tabs--ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap !important;
    justify-content: space-evenly;
  }

  .vs-tabs--li {
    flex-grow: 1 !important;
  }

  .line-vs-tabs {
    display: none;
  }

  .vs-tabs--li.activeChild {
    border-width: 0 0 2px 0;
    border-color: transparent;
    border-style: solid;
  }
}
</style>
